export function initializePricingPage() {
    const pricingToggle = document.getHtmlElementById("pricingToggle");
    if (pricingToggle) {
        const priceContainers = document.queryHtmlElements(".price-container");
        function updatePrices(isYearly) {
            for (const container of priceContainers) {
                const monthly = container.dataset.monthlyPrice || "";
                const annual = container.dataset.annualPrice || "";
                const monthlyId = container.dataset.monthlyPriceId || "";
                const annualId = container.dataset.annualPriceId || "";
                const rpm = container.dataset.rpm || "";
                const priceSpan = container.querySelector(".price-value");
                const periodSpan = container.querySelector(".pricing-period");
                const subscribeButton = document.getHtmlElementById(`rpm-${rpm}`);
                if (priceSpan && periodSpan) {
                    priceSpan.textContent = isYearly ? annual : monthly;
                    periodSpan.textContent = isYearly ? "per year" : "per month";
                }
                if (subscribeButton) {
                    const path = `/Subscription/RedirectToPrice/${isYearly ? annualId : monthlyId}`;
                    subscribeButton.href = path;
                }
            }
        }
        pricingToggle.addEventListener("change", function () {
            updatePrices(this.checked);
        });
    }
}
